import React, { useState } from 'react';
import containerAPI from '../../services/containerAPI';

const QuickContainerModal = ({ containerNumber, onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    containerNumber: containerNumber,
    bookingNumber: '',
    shippingLine: 'CMA_CGM',
    size: '40FT',
    type: 'DRY'
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await containerAPI.create(formData);
      onSuccess();
    } catch (error) {
      alert('Error creating container: ' + error.message);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Create New Container</h3>
          <button className="close-btn" onClick={onCancel}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Container Number</label>
            <input
              type="text"
              value={formData.containerNumber}
              readOnly
              className="readonly-input"
            />
          </div>
          <div className="form-group">
            <label>Booking Number *</label>
            <input
              type="text"
              value={formData.bookingNumber}
              onChange={(e) => setFormData({...formData, bookingNumber: e.target.value})}
              required
              placeholder="e.g., SHIP-6482"
            />
          </div>
          <div className="form-actions">
            <button type="button" className="btn-secondary" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className="btn-primary">
              Create Container
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QuickContainerModal;
/** Modal Button Styles */
const modalBtnStyle = document.createElement('style');
modalBtnStyle.innerHTML = `
  .form-actions {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 1.5rem;
  }
  .btn-primary {
    background: #007bff;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 0.5rem 1.5rem;
    font-size: 1rem;
    cursor: pointer;
    transition: background 0.2s;
  }
  .btn-primary:hover {
    background: #0056b3;
  }
  .btn-secondary {
    background: #f5f5f5;
    color: #333;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0.5rem 1.5rem;
    font-size: 1rem;
    cursor: pointer;
    transition: background 0.2s;
  }
  .btn-secondary:hover {
    background: #e2e2e2;
  }
`;
if (typeof window !== 'undefined' && !document.head.querySelector('style[data-modal-btn]')) {
  modalBtnStyle.setAttribute('data-modal-btn', '');
  document.head.appendChild(modalBtnStyle);
}
/** Modal Styles */
const modalStyle = document.createElement('style');
modalStyle.innerHTML = `
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .modal-content {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 16px rgba(0,0,0,0.2);
    padding: 2rem;
    min-width: 350px;
    max-width: 90vw;
    position: relative;
  }
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }
  .close-btn {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #888;
  }
`;
if (typeof window !== 'undefined' && !document.head.querySelector('style[data-modal]')) {
  modalStyle.setAttribute('data-modal', '');
  document.head.appendChild(modalStyle);
}